import { render, staticRenderFns } from "./EntregaMsgErroComprometimento.vue?vue&type=template&id=3227a820"
import script from "./EntregaMsgErroComprometimento.vue?vue&type=script&lang=js"
export * from "./EntregaMsgErroComprometimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports